module.exports = __webpack_public_path__ + "img/cru.ef7d1e0.png";